import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeaderComponent} from './header/header.component';
import { IonicModule } from '@ionic/angular';
import {RouterModule} from "@angular/router";
import {InfoProductComponent} from "./info-product/info-product.component";
import {ExpandableComponent} from "./expandable/expandable.component";

@NgModule({
    declarations: [
        HeaderComponent,
        InfoProductComponent,
        ExpandableComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        RouterModule,
    ],
    exports: [HeaderComponent, InfoProductComponent, ExpandableComponent],
})
export class ComponentsModule { }